// Mantine bound to the design tokens.
//
// The app used to run a DARK theme with a different blue and system fonts. The
// design system is light, warm (#FCFCFA, never pure white), and typeset in
// Bricolage Grotesque / IBM Plex Mono. Every value here comes from
// design/tokens.ts — Mantine renders the design language; it doesn't define a
// second one.

import { type MantineColorsTuple, createTheme } from "@mantine/core";
import { c, font, radius } from "./design/tokens.ts";

/** The accent ramp, anchored on #1B4FFF at index 6 (Mantine's default shade). */
const brand: MantineColorsTuple = [
  "#F0F3FF",
  "#D6DEFF",
  "#AEBEFF",
  "#829CFF",
  "#5C7EFF",
  "#3A65FF",
  c.blue, // 6 — the accent
  c.blueHover,
  "#0F32AB",
  "#0A2588",
];

/** Warm neutral ramp. Mantine's stock grey is cold; the design's neutrals aren't. */
const sand: MantineColorsTuple = [
  c.bg,
  c.bgAlt,
  c.bgHover,
  c.border,
  c.borderStrong,
  c.faint,
  c.muted,
  "#3F3F49",
  "#26262F",
  c.ink,
];

export const theme = createTheme({
  fontFamily: font.sans,
  fontFamilyMonospace: font.mono,
  headings: {
    fontFamily: font.sans,
    fontWeight: "800",
    sizes: {
      h1: { fontSize: "30px", lineHeight: "1.15" },
      h2: { fontSize: "22px", lineHeight: "1.25" },
      h3: { fontSize: "17px", lineHeight: "1.35" },
    },
  },
  primaryColor: "brand",
  primaryShade: 6,
  colors: { brand, sand },
  white: c.bg,
  black: c.ink,
  defaultRadius: "md",
  radius: {
    xs: "6px",
    sm: `${radius.chip}px`,
    md: `${radius.input}px`,
    lg: `${radius.panel}px`,
    xl: `${radius.card}px`,
  },
  components: {
    // The design has NO square buttons — pills everywhere, by default.
    Button: { defaultProps: { radius: radius.pill } },
    Badge: { defaultProps: { radius: radius.pill } },
    Card: { defaultProps: { radius: "lg", withBorder: true } },
  },
});
